/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { WebQuestionAnswersTypeModel, WebQuestionAnswersTypeModelType } from './WebQuestionAnswersTypeModel'
import { WebQuestionAnswersTypeModelSelector } from './WebQuestionAnswersTypeModel.base'
import { RootStoreType } from './index'

/**
 * AnonymousUserBase
 * auto generated base class for the model AnonymousUserModel.
 */
export const AnonymousUserModelBase = ModelBase.named('AnonymousUser')
  .props({
    __typename: types.optional(types.literal('AnonymousUser'), 'AnonymousUser'),
    _id: types.identifier,
    address: types.union(types.undefined, types.null, types.string),
    age: types.union(types.undefined, types.null, types.string),
    branchUrl: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    email: types.union(types.undefined, types.string),
    firstName: types.union(types.undefined, types.null, types.string),
    heardAboutPokerPower: types.union(types.undefined, types.null, types.string),
    lastName: types.union(types.undefined, types.null, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    promoCode: types.union(types.undefined, types.null, types.string),
    segmentAnonymousId: types.union(types.undefined, types.null, types.string),
    stripeId: types.union(types.undefined, types.null, types.string),
    updatedAt: types.union(types.undefined, types.frozen()),
    webQuestionAnswers: types.union(
      types.undefined,
      types.null,
      types.array(types.late(() => WebQuestionAnswersTypeModel))
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class AnonymousUserModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get address() {
    return this.__attr('address')
  }
  get age() {
    return this.__attr('age')
  }
  get branchUrl() {
    return this.__attr('branchUrl')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get email() {
    return this.__attr('email')
  }
  get firstName() {
    return this.__attr('firstName')
  }
  get heardAboutPokerPower() {
    return this.__attr('heardAboutPokerPower')
  }
  get lastName() {
    return this.__attr('lastName')
  }
  get phoneNumber() {
    return this.__attr('phoneNumber')
  }
  get promoCode() {
    return this.__attr('promoCode')
  }
  get segmentAnonymousId() {
    return this.__attr('segmentAnonymousId')
  }
  get stripeId() {
    return this.__attr('stripeId')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  webQuestionAnswers(
    builder:
      | string
      | WebQuestionAnswersTypeModelSelector
      | ((selector: WebQuestionAnswersTypeModelSelector) => WebQuestionAnswersTypeModelSelector)
      | undefined
  ) {
    return this.__child('webQuestionAnswers', WebQuestionAnswersTypeModelSelector, builder)
  }
}
export function selectFromAnonymousUser() {
  return new AnonymousUserModelSelector()
}

export const anonymousUserModelPrimitives =
  selectFromAnonymousUser()._id.address.age.branchUrl.createdAt.email.firstName.heardAboutPokerPower.lastName
    .phoneNumber.promoCode.segmentAnonymousId.stripeId.updatedAt
